window.$ = window.jQuery = require('jquery')
export default function toggleBtn() {
  $(() => {
    $('.k-sp-header-menu-btn').on('click', function(){
      $(this).toggleClass('k-sp-header-menu-btn-active');
      $('.k-header').toggleClass('k-header-active');
      $('body').toggleClass('k-sp-header-menu-active');
      return false;
    });
  });
}
